import { LitElement, html, css, styleMap, utils } from '@hh/global.js';
class HHStickyHeader extends LitElement {
  static properties = {
    closeWhenHidden: {
      type: String,
      attribute: 'close-when-hidden',
    },
    _state: {
      type: Number,
      state: true,
    },
    _height: {
      type: Number,
      state: true,
    },
  }

  constructor() {
    super()

    this.headerBounds = {}
    this.currentScrollTop = 0
    this.closeWhenHidden = 'hh-details-modal'

    this._state = -1
  }

  connectedCallback() {
    super.connectedCallback()
    this.onScrollHandler = this.onScroll.bind(this)
    window.addEventListener('scroll', this.onScrollHandler)
    window.addEventListener('resize', this.setSpacerHeight.bind(this));
    this.createObserver();
    this.setSpacerHeight();

    const announcementBar = document.getElementById('shopify-section-announcement-bar')
    if (announcementBar) {
      announcementBar.addEventListener('click', this.setSpacerHeight.bind(this))
      
      const observer = new MutationObserver(this.setSpacerHeight.bind(this))
      observer.observe(announcementBar, {
        attributes: true,
        attributeFilter: ['style', 'class'],
      })
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('scroll', this.onScrollHandler)
    window.removeEventListener('resize', this.setSpacerHeight.bind(this))
  }

  updated(changedProperties) {
    if (changedProperties.has('_state')) {
      document.body.classList[this._state === 2 ? 'add' : 'remove'](
        'sticky-header-scroll-up'
      )
    }
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect
      observer.disconnect()
    })

    observer.observe(this)
  }

  async setSpacerHeight(retries = 5, maxHeight = 700) {
    try {
      setTimeout(() => {
        const announcementBar = document.getElementById('shopify-section-announcement-bar')
        const header = document.querySelector('hh-header')

        let totalHeight = 0
        if (announcementBar && announcementBar.offsetHeight > 0) {
          totalHeight += announcementBar.offsetHeight
        }
        if (header) {
          totalHeight += header.offsetHeight
        }
        HH.setCSSVariable(
          '--hh-total-header-height',
          `${totalHeight}px`
        )
        this._height = totalHeight
        this._state = 0
      }, 200)

    } catch (error) {
      if (retries > 0) {
        await new Promise((resolve) => setTimeout(resolve, 1000))
        await this.setSpacerHeight(retries - 1)
      } else {
        console.error('Failed to set spacer height:', error)
      }
    }
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      requestAnimationFrame(this.hide.bind(this))
    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      requestAnimationFrame(this.reveal.bind(this))
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this))
    }

    this.currentScrollTop = scrollTop
  }

  hide() {
    if (this._state === 1) {
      return
    }
    this._state = 1

    utils.all(this.closeWhenHidden, this.header).map((element) => {
      element.setAttribute('open', false)
    })
  }

  reveal() {
    if (this._state === 2) {
      return
    }
    this._state = 2
  }

  reset() {
    if (this._state === 0) {
      return
    }
    this._state = 0
  }

  render() {
    return html`
      <div
        class="container"
        style="${styleMap({
          position: this._state === -1 ? 'relative' : 'fixed',
          transform: this._state === 1 ? `translateY(-100%)` : 'translateY(0)',
        })}"
      >
        <slot></slot>
      </div>
      <div
        class="spacer"
        style="${styleMap({
          height: `${this._height}px`,
        })}"
      ></div>
    `
  }

  static styles = css`
    .container {
      left: 0;
      width: 100%;
      z-index: var(--hh-z-index, 100);
      transform: translateY(0);
      transition: transform var(--hh-duration-long, 500ms);
      background-color: var(--hh-background, transparent);
    }

    .spacer {
      position: relative;
    }
  `
}

if (!customElements.get('hh-sticky-header')) {
  customElements.define('hh-sticky-header', HHStickyHeader);
}
